<template>
    <v-card>
        <v-card-title style="background-color:#4E87DD; color:#FFFFFF; height:70px;">
            <v-row no-gutters>
                <v-col class="pt-1 pl-4 text-h5 font-weight-bold">비밀번호 변경</v-col>
            </v-row>
        </v-card-title>
        
        <v-card-text class="mt-3 pb-0 pl-7 pr-7 pt-3">
            <v-row no-gutters>
                <v-col class="pt-0 pb-0 title" style="color:#999999">새 비밀번호<span style="color:red; padding-left:5px;">*</span></v-col>
            </v-row>
            <v-row no-gutters>
                <v-col class="pt-2 pb-4">
                    <v-text-field outlined hide-details :error="passwordForm.newPassword.err" type="password" 
                                  placeholder="새 비밀번호를 입력해 주세요" v-model="newPassword"
                                  @keyup="validatePassword('newPassword')" @change="validatePassword('newPassword', true)">
                        <template v-slot:append v-if="passwordForm.newPassword.err_msg">
                            <div style="color:#FF4D4D; font-size:13px; padding-top:5px;">
                                {{ passwordForm.newPassword.err_msg }}
                            </div>
                        </template>
                    </v-text-field>
                </v-col>
            </v-row>
            
            <v-row no-gutters>
                <v-col class="pt-0 pb-0 title" style="color:#999999">비밀번호 확인<span style="color:red; padding-left:5px;">*</span></v-col>
            </v-row>
            <v-row no-gutters>
                <v-col class="pt-2 pb-0">
                    <v-text-field outlined hide-details :error="passwordForm.confirmPassword.err" type="password" 
                                  placeholder="비밀번호를 다시 입력해 주세요" v-model="confirmPassword"
                                  @keyup="validatePassword('confirmPassword')" @change="validatePassword('confirmPassword', true)"
                                  @keydown.enter="submit">
                        <template v-slot:append v-if="passwordForm.confirmPassword.err_msg">
                            <div style="color:#FF4D4D; font-size:13px; padding-top:5px;">
                                {{ passwordForm.confirmPassword.err_msg }}
                            </div>
                        </template>
                    </v-text-field>
                </v-col>
            </v-row>
        </v-card-text>
        
        <v-card-actions class="ma-0 pa-0">
            <v-row no-gutters>
                <v-col cols="12" class="pr-5 pb-6 pt-5 text-right">
                    <v-btn class="ma-2" width="130px" color="primary" text @click="close">
                        <span style="color:#555555; font-size:1.4em;">취소</span>
                    </v-btn>
                    <v-btn class="ma-2 white--text" width="130px" color="#4573D5" large 
                           @click="submit" :disabled="!isFormValid">
                        <span style="font-size:1.4em;">변경</span>
                    </v-btn>
                </v-col>
            </v-row>
        </v-card-actions>
    </v-card>
</template>

<script>

import authApi from '@/api/auth'
import {passwordValidator} from '@/utils/passwordValidator'

export default {
    name: 'PopupInitPassword',
    props: ['adminUserId'],
    data: () => ({
        newPassword: '',
        confirmPassword: '',
        passwordForm: {
            newPassword: {
                err: false,
                err_msg: ''
            },
            confirmPassword: {
                err: false,
                err_msg: ''
            }
        }
    }),
    computed: {
        isFormValid() {
            return this.newPassword && this.confirmPassword &&
                   !this.passwordForm.newPassword.err && !this.passwordForm.confirmPassword.err
        }
    },
    methods: {
        validatePassword(field) {
            if (field === 'newPassword') {
                const validation = passwordValidator.validateNewPassword(this.newPassword)
                passwordValidator.updateFormStatus(this.passwordForm, 'newPassword', !validation.isValid, validation.message)
                
                if (this.confirmPassword) {
                    const matchValidation = passwordValidator.validatePasswordMatch(this.newPassword, this.confirmPassword)
                    passwordValidator.updateFormStatus(this.passwordForm, 'confirmPassword', !matchValidation.isValid, matchValidation.message)
                }
            } else if (field === 'confirmPassword') {
                const validation = passwordValidator.validatePasswordMatch(this.newPassword, this.confirmPassword)
                passwordValidator.updateFormStatus(this.passwordForm, 'confirmPassword', !validation.isValid, validation.message)
            }
        },
        close() {
            this.$emit('close')
        },
        submit() {
            authApi.initPassword(
                {
                    new_password: this.newPassword,
                    new_password_confirm: this.confirmPassword,
                    admin_user_id: this.adminUserId
                },(va) => {
                    va.$store.dispatch('openAlert', {
                        message: `비밀번호가 변경되었습니다.<br />새로운 비밀번호로 다시 로그인해주시기 바랍니다.`,
                        closeCb: () => {
                            va.$emit('close')
                            va.$store.dispatch('login/LOGOUT', {serverFlag: true}).then(() => {})
                        }
                    })
                },(err, va) => {
                    va.$store.dispatch('openAlert', {message: `${err}`})
                }, this
            )
        }
    }
}
</script>